import { MatchStatsCore } from '../core';

export class MatchStats extends MatchStatsCore {
	get match_stats_headings() {
		return [
			{ key: 'TOG', heading: 'MP', tooltip: 'Minutes Played' },
			{ key: 'T', heading: 'T', tooltip: 'Tries' },
			{ key: 'TS', heading: 'TS', tooltip: 'Try Saves' },
			{ key: 'G', heading: 'G', tooltip: 'Goals' },
			{ key: 'FG', heading: 'FG', tooltip: 'Field Goals' },
			{ key: 'TA', heading: 'TA', tooltip: 'Try Assists' },
			{ key: 'LB', heading: 'LB', tooltip: 'Line Breaks' },
			{ key: 'LBA', heading: 'LBA', tooltip: 'Line Break Assists' },
			{ key: 'TCK', heading: 'TCK', tooltip: 'Tackles' },
			{ key: 'TB', heading: 'TB', tooltip: 'Tackle Breaks' },
			{ key: 'MT', heading: 'MT', tooltip: 'Missed Tackles' },
			{ key: 'OFG', heading: 'OFG', tooltip: 'Ground Offloads' },
			{ key: 'OFH', heading: 'OFH', tooltip: 'Hand Offloads' },
			{ key: 'ER', heading: 'ER', tooltip: 'Errors' },
			{ key: 'TO', heading: 'TO', tooltip: 'Turnovers' },
			{ key: 'FTF', heading: 'FTF', tooltip: '40/20/40\'s' },
			{ key: 'MG', heading: 'MG', tooltip: 'Total Metres gained' },
			{ key: 'KM', heading: 'KM', tooltip: 'Kick Metres' },
			{ key: 'KD', heading: 'KD', tooltip: 'Kicks Defused' },
			{ key: 'PC', heading: 'PC', tooltip: 'Penalties conceded' },
			{ key: 'SB', heading: 'SB', tooltip: 'Sin-Bin' },
			{ key: 'SO', heading: 'SO', tooltip: 'Send-Off' },
			{ key: 'FDO', heading: 'FDO', tooltip: 'Forced Drop Out' },
			{ key: 'SAI', heading: 'SAI', tooltip: 'Six Again Infringments' },
			{ key: 'EFIG', heading: 'EFIG', tooltip: 'Escape From In Goal' }
		]
	}
	initialize() {
		this.setRoundId(1);
		this.prefix = 'nrl/';
	}

	setRoundId(round_id) {
		this.url = `stats/${round_id}.json`;
	}

	setPlayerId( player_id ) {
		this.url = `stats/players/${player_id}.json`;
		return this;
	}

	setCoachPlayerId( player_id ) {
		this.url = `coach/players/${player_id}.json`;
		return this;
	}

}

export default MatchStats;